export default __webpack_public_path__ + "static/media/right.b4a17d96.png";